import { AppBar, Container, Grid, Toolbar } from '@mui/material'
import useHelpDocuments from 'hooks/useHelpDocument/useHelpDocument'
import Navigation from './Navigation'
import DocumentDisplay from './DocumentDisplay'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { groupBy } from 'lodash-es'
import { useHistory, useLocation } from 'react-router-dom'
import replaceDocumentRoute from './helper/replaceDocumentRoute'

function DocumentPage() {
    const { docs } = useHelpDocuments()
    const history = useHistory()
    const location = useLocation()
    const [selectDocId, setSelectDocId] = useState<number>(1)

    const docList = useMemo(
        () =>
            groupBy(
                docs.filter((i) => i.category !== 'help'),
                (i) => i.category,
            ),
        [docs],
    )

    const displayDoc = useMemo(() => docs.find((d) => d.id === selectDocId), [
        docs,
        selectDocId,
    ])

    const replaceRoute = useCallback(
        (category: string, title: string) => {
            history.replace(replaceDocumentRoute(category, title))
        },
        [history],
    )
    const onSelectDocId = useCallback(
        (docId: number) => {
            const doc = docs.find((d) => d.id === docId)
            if (!doc) return
            setSelectDocId(docId)
            replaceRoute(doc.category, doc.title)
        },
        [docs, replaceRoute],
    )

    useEffect(() => {
        const [, , category, title] = location.pathname.split('/')
        const document = docs.find(
            (i) => i.category === category && i.title === title,
        )!!
        if (document) {
            replaceRoute(document.category, document.title)
            setSelectDocId(document.id)
            window.scrollTo({ top: 0, behavior: 'auto' })
        }
    }, [docs, location.pathname, replaceRoute])

    return (
        <Container sx={{ maxWidth: '90vw', margin: 0, padding: 0 }}>
            <AppBar>
                <Toolbar>Docs</Toolbar>
            </AppBar>
            <Grid
                container
                spacing={4}
                justifyContent="space-between"
                marginTop={8}
                direction="row"
            >
                <Grid item xs={4} marginTop={4}>
                    <Navigation
                        docList={docList}
                        selectDocId={selectDocId}
                        onSelectDocId={onSelectDocId}
                    />
                </Grid>
                <Grid item xs={8}>
                    <DocumentDisplay docs={docs} displayDoc={displayDoc} />
                </Grid>
            </Grid>
        </Container>
    )
}
export default DocumentPage
